var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinumPartnerMedallionLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PlatinumPartner-medallion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.118,
    height: 157.964,
    viewBox: "0 0 111.118 157.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31926",
    "data-name": "Rectangle 31926",
    width: 111.118,
    height: 157.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40668",
    "data-name": "Path 40668",
    d: "M86.8,175.8a55.512,55.512,0,0,0,82.606-74.178,56.814,56.814,0,0,0-4.136-4.149L86.8,175.81Z",
    transform: "translate(-86.8 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -16.498,
    y1: -8.875,
    x2: -16.498,
    y2: -8.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e3f3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40669",
    "data-name": "Path 40669",
    d: "M85.52,139.551c0,24.92,19.734,45.121,44.058,45.121s44.058-20.2,44.058-45.121S153.9,94.43,129.578,94.43s-44.058,20.2-44.058,45.121",
    transform: "translate(-85.52 -94.43)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -19.241,
    y1: -10.109,
    x2: -19.241,
    y2: -10.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8687a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8687a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M127.062,50.26,105.85,90.649h31.339L158.647,50.26H127.062Z",
    transform: "translate(-66.861 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14177",
    "data-name": "Group 14177",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 35.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M147.628,77.38h-4.655a1.463,1.463,0,0,0-1.465,1.465h0v3.54a2.236,2.236,0,0,1-2.243,2.243H112.154a2.236,2.236,0,0,1-2.243-2.243h0v-3.54a1.464,1.464,0,0,0-1.465-1.465H103.4a1.448,1.448,0,0,0-1.4,1.037L95.44,99.656h60.176l-6.561-21.238a1.475,1.475,0,0,0-1.4-1.037",
    transform: "translate(-69.949 -77.38)",
    fill: "#81849b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M131.339,86.44A55.562,55.562,0,0,0,90.068,179.2l78.47-78.47a55.3,55.3,0,0,0-37.2-14.288",
    transform: "translate(-75.78 -74.693)",
    fill: "#b7b8d2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(14.288 61.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14178",
    "data-name": "Group 14178",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 103.105,
    height: 103.04,
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14179",
    "data-name": "Group 14179",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(10.36 57.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M128.969,94.43a45.122,45.122,0,1,1-45.2,45.122,45.121,45.121,0,0,1,45.2-45.122h0",
    transform: "translate(-83.77 -94.43)",
    fill: "#81849b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(12.629 57.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14180",
    "data-name": "Group 14180",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 88.13,
    height: 90.243,
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14181",
    "data-name": "Group 14181",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(14.989 0.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M143.819,90.631H112.481L87.34,50.32h31.831Z",
    transform: "translate(-87.34 -50.32)",
    fill: "#57a932"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40670",
    "data-name": "Path 40670",
    d: "M124.832,160.962l-13.55-23.481L97.72,114h54.224l-13.55,23.481-13.562,23.481Z",
    transform: "translate(-69.273 -31.355)",
    fill: "#c7c7df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40671",
    "data-name": "Path 40671",
    d: "M124.636,158.03l-12.357-21.42L99.91,115.19h49.465l-12.37,21.42-12.37,21.42Z",
    transform: "translate(-68.623 -31.003)",
    fill: "#e6e5f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumPartnerMedallionLg);
export default __webpack_public_path__ + "static/media/PlatinumPartner-medallionLg.b7a9396b5026a6b4cf8802f37114ace8.svg";
export { ForwardRef as ReactComponent };